export enum DelfiField {
  ALLERGENS = 'allergens',
  TEMPLATE = 'template',
  PICTOGRAMS = 'pictograms',
}
